import { useCanAdministerAIAgents } from "~/pages/manifold-nextgen/hooks/useCanAdministerAIAgents";
import { Agent, AgentAccessLevel, AgentScope } from "~/services/agents";

// Deleting an agent maps to the owner-only `can_delete` grant; editors and
// USER-level grants never confer it. SYSTEM agents cannot be deleted via HTTP
// (they are owned by the seed YAML), so it is unavailable regardless of level —
// even to an `admin:agents` caller. Otherwise an admin can delete any CUSTOMER
// agent via the FGA bypass. Distinct from editing (`can_edit`), which editors
// also hold.
export const useCanDeleteAgent = (agent: Agent | undefined): boolean => {
  const isAdmin = useCanAdministerAIAgents();
  return (
    !!agent &&
    agent.scope === AgentScope.CUSTOMER &&
    (agent.access_level === AgentAccessLevel.OWNER || isAdmin)
  );
};
